//event list
const options = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};
const payPalUrl = "https://www.paypal.com/cgi-bin/webscr?item_name=";

export const groupBy = (items, key) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {}
  );

export const keywordsExtract = (items) => {
  console.log("process metadata");
  const grouped = [];
  const group = items.filter((x) => x.metadata !== undefined);
  let filterName = "";
  console.log(group);
  for (const [key, value] of Object.entries(group)) {
    console.log("m");
    console.log(value);
    //get keywords
    if (
      value &&
      value.metadata &&
      value.metadata.keywords &&
      value.metadata.keywords.length > 0
    ) {
      for (const keyword of value.metadata.keywords) {
        if (!grouped.includes(keyword)) {
          grouped.push(keyword);
        }
      }
      //get filterName
      if (filterName === "") {
        if (value.metadata.name) {
          filterName = value.metadata.name;
        }
      }
    }
  }
  if (filterName !== "") {
    filterName = filterName.toUpperCase();
  }
  return { list: grouped, name: filterName };
};

export const groupExtract = (items, key) => {
  console.log("group extract");
  const grouped = [];
  const group = groupBy(items, key);
  for (const [key, value] of Object.entries(group)) {
    console.log(key);
    grouped.push(key);
  }
  return grouped;
};

export function sortByTitle(a, b) {
  const tA = a.title.toUpperCase(); // ignore upper and lowercase
  const tB = b.title.toUpperCase(); // ignore upper and lowercase
  if (tA < tB) {
    return -1;
  }
  if (tA > tB) {
    return 1;
  }
  // titles must be equal
  return 0;
}

export function sortByValue(a, b) {
  const tA = a.toUpperCase(); // ignore upper and lowercase
  const tB = b.toUpperCase(); // ignore upper and lowercase
  if (tA < tB) {
    return -1;
  }
  if (tA > tB) {
    return 1;
  }
  // titles must be equal
  return 0;
}

export function getNavigatorLanguage(navigator) {
  let l_lang;
  if (navigator.userLanguage) l_lang = navigator.userLanguage;
  else if (navigator.language) l_lang = navigator.language;
  else l_lang = "en";

  if (l_lang.includes("-")) {
    l_lang = l_lang.split("-")[0];
  }

  return l_lang;
}

export function getValidDate(item) {
  const date = new Date(Number(item) * 1000);
  return date;
}

export function getHeaderDate(item) {
  //console.log(item);
  //isValidDate(item)
  const date = getValidDate(item.date);
  const l_lang = getNavigatorLanguage(navigator);

  return date.toLocaleDateString(l_lang, options);
}

export function getHeaderDateLocal(item, lang) {
  const date = getValidDate(item.date);
  const str = date.toLocaleDateString(lang, options);

  return str;
}

export async function jsonReqPost(url, data) {
  const response = await fetch(url, {
    method: "POST",
    mode: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });

  console.log(response.status);

  if (response.status === 200) {
    return response.json();
  } else {
    console.log("err request");
    return response;
  }
}

export async function jsonReq(url) {
  const response = await fetch(url, {
    credentials: "include",
  });
  console.log(response.status);

  if (response.status === 200) {
    return response.json();
  } else {
    console.log("err request");
    return response;
  }
}

export function triangleBackground(usercolor) {
  return (
    "url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23" +
    usercolor +
    "%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')"
  );
}

export function itemClick(item) {
  console.log(item);
  if (typeof item.id !== "undefined" && item.id && item.id > -1) {
    //navigate
    console.log("nav to:" + item.id);
    if (typeof window.kendoMobileApplication !== "undefined") {
      console.log("has kendo");
      window.kendoMobileApplication.navigate("#" + item.id);
    } else {
      location.hash = item.id;
    }
  } else {
    //action
    console.log("do action");

    let title = item.label;

    if (!title) {
      title = item.title;
    }

    if (item.value && item.value._class) {
      processLinkJS(item, title);
    } else {
      processLinkJS(item.link, title);
    }
  }
}

function processLinkJS(item, title) {
  //y
  console.log(item);
  let preview = false;

  if (window.location.href.toLowerCase().indexOf("preview") > -1) {
    preview = true;
  }

  const link = item;

  switch (link.value._class.toLowerCase()) {
    case "action_dial":
      if (preview) {
        showNotInPreviewMessage();
      } else {
        if (pg) {
          OpenPhoneGapLinkinAppExt("tel:" + link.value.number);
        } else {
          window.location.href = "tel:" + link.value.number;
        }
      }
      break;
    case "action_email":
      if (preview) {
        showNotInPreviewMessage();
      } else {
        let email = "mailto:" + link.value.to + "?";

        if (typeof link.value.cc !== "undefined" && link.value.cc !== null) {
          email += "cc=" + link.value.cc + "&";
        }

        if (
          typeof link.value.subject !== "undefined" &&
          link.value.subject !== null
        ) {
          email += "subject=" + encodeURIComponent(link.value.subject) + "&";
        }

        if (
          typeof link.value.body !== "undefined" &&
          link.value.body !== null
        ) {
          // if(CheckFlutterSvelte()){
          //     email += 'body=' + encodeURIComponent(link.value.body);
          //}else{
          //.replace(/\n/g,'<br/>')
          const body = link.value.body; //.replace(/\n/g,'<br>');

          if (idevice) {
            console.log(body);
            try {
              if (ios14 || ios15) {
                email +=
                  "body=<html>%0D%0A" +
                  body.replace(/\n/g, "%0D%0A") +
                  "%0D%0A</html>";
              } else {
                email += "body=" + body.replace(/\n/g, "<br/>");
              }
            } catch {
              email += "body=" + body.replace(/\n/g, "<br/>");
            }
          } else {
            email += "body=" + encodeURIComponent(body);
          }
          //}
        }
        if (pg) {
          OpenPhoneGapLinkinAppExt(email);
        } else {
          window.location.href = email;
        }
      }
      break;

    case "action_sms":
      if (preview) {
        showNotInPreviewMessage();
      } else {
        if (pg) {
          OpenPhoneGapLinkinAppExt("sms:" + link.value.number);
        } else {
          window.location.href = "sms:" + link.value.number;
        }
      }
      break;
    case "action_multilocation":
    case "action_maplocation":
    case "action_route":
    case "action_map":
      if (preview) {
        showNotInPreviewMessage();
      } else {
        GetMapURL(link.value.parameters);
      }
      break;
    case "action_websiteexternal":
        if (preview) {
          showNotInPreviewMessage();
        } else {
        if(CheckFlutterSvelte()){
          OpenInWebView(link.value.url, title,link.value?.isExternalAction ?? false);
        }else{
          window.open(
            link.value.url
        );
        }
          
        }
        break;
    case "action_appstore":
      if (preview) {
        showNotInPreviewMessage();
      } else {
        window.open(
          "https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=" +
            link.value.item
        );
      }
      break;

    case "action_donation":
      if (preview) {
        showNotInPreviewMessage();
      } else {
        let doncur = "USD";
        if (link.value.currency !== "" && link.value.currency !== null) {
          doncur = link.value.currency;
        }

        if (pg) {
          OpenPhoneGapLinkinAppExt(
            payPalUrl +
              encodeURIComponent(link.value.title) +
              "&amount=" +
              link.value.price +
              "&cmd=_donations&business=" +
              link.value.to +
              "&bn=JavaScriptButton_donate&env=www&currency_code=" +
              doncur +
              "&"
          );
          //action = '<a data-rel="external" class="loadInAppBrowserExt" data-url="https://www.paypal.com/cgi-bin/webscr?item_name=' + link.value.title + '&amount=' + link.value.price + '&cmd=_donations&business=' + link.value.to + '&bn=JavaScriptButton_donate&env=www&currency_code=' + doncur + '&">' + content + '</a>';
        } else {
          if (CheckFlutterSvelte()) {
            OpenInWebView(
              payPalUrl +
                encodeURIComponent(link.value.title) +
                "&amount=" +
                link.value.price +
                "&cmd=_donations&business=" +
                link.value.to +
                "&bn=JavaScriptButton_donate&env=www&currency_code=" +
                doncur +
                "&",
              title
            );
          } else {
            window.open(
              payPalUrl +
                encodeURIComponent(link.value.title) +
                "&amount=" +
                link.value.price +
                "&cmd=_donations&business=" +
                link.value.to +
                "&bn=JavaScriptButton_donate&env=www&currency_code=" +
                doncur +
                "&"
            );
          }
        }
      }
      break;
    case "action_payment":
      if (preview) {
        showNotInPreviewMessage();
      } else {
        let paycur = "USD";
        if (link.value.currency !== "" && link.value.currency !== null) {
          paycur = link.value.currency;
        }

        if (pg) {
          OpenPhoneGapLinkinAppExt(
            payPalUrl +
              encodeURIComponent(link.value.title) +
              "&amount=" +
              link.value.price +
              "&cmd=_xclick&business=" +
              link.value.to +
              "&bn=JavaScriptButton_buynow&env=www&currency_code=" +
              paycur +
              "&"
          );
          //action = '<a data-rel="external" class="loadInAppBrowserExt" data-url="https://www.paypal.com/cgi-bin/webscr?item_name=' + link.value.title + '&amount=' + link.value.price + '&cmd=_xclick&business=' + link.value.to + '&bn=JavaScriptButton_buynow&env=www&currency_code=' + paycur + '&">' + content + '</a>';
        } else {
          if (CheckFlutterSvelte()) {
            OpenInWebView(
              payPalUrl +
                encodeURIComponent(link.value.title) +
                "&amount=" +
                link.value.price +
                "&cmd=_xclick&business=" +
                link.value.to +
                "&bn=JavaScriptButton_buynow&env=www&currency_code=" +
                paycur +
                "&",
              title
            );
          } else {
            window.open(
              payPalUrl +
                encodeURIComponent(link.value.title) +
                "&amount=" +
                link.value.price +
                "&cmd=_xclick&business=" +
                link.value.to +
                "&bn=JavaScriptButton_buynow&env=www&currency_code=" +
                paycur +
                "&"
            );
          }
        }
      }
      break;

    default:
      console.log("default action");
      if (
        pg ||
        (link.value.url.indexOf("http") > -1 &&
          iframeready &&
          link.value._class !== "Action_WebsiteExternal" &&
          link.value._class !== "Action_Whatsapp")
      ) {
        if (pg) {
          if (
            link.value._class === "Action_WebsiteExternal" ||
            link.value._class === "Action_Whatsapp"
          ) {
            OpenPhoneGapLinkinAppExt(link.value.url);
            //action = '<a href="javascript:' + OpenPhoneGapLinkinAppExt(link.value.url) + '">' + content + '</a>';
          } else {
            if (
              getParameterByName("native") > 0 ||
              getParameterByName("nativepush") > 0
            ) {
              OpenPhoneGapLinkinAppThemed(link.value.url, userColor);
              //action = '<a href="javascript:' + OpenPhoneGapLinkinAppThemed(link.value.url, userColor) + '">' + content + '</a>';
            } else {
              OpenPhoneGapLinkinApp(link.value.url);
              //action = '<a href="javascript:' + OpenPhoneGapLinkinApp(link.value.url) + '">' + content + '</a>';
            }
          }
        } else {
          console.log("check native");

          if (CheckFlutterSvelte()) {
            OpenInWebView(link.value.url, title);
          } else {
            OpenIframeOrNot(link.value.url, title, false);
          }
        }
      } else {
        console.log("other actions");
        if (preview) {
          showNotInPreviewMessage();
        } else {
          console.log("check native");
          if (CheckFlutterSvelte()) {
            OpenInWebView(link.value.url, title);
          } else {
            window.open(link.value.url);
          }
        }
      }
      break;
  }
}

function CheckFlutterSvelte() {
  const str = location.href.toLowerCase();

  if (str.indexOf("flutter=") > -1) {
    console.log("Flutter");
    return true;
  } else {
    return false;
  }
}

// const backgroundDataURI = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwgAADsIBFShKgAAAABl0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC4xMzQDW3oAAAANSURBVBhXY/j3798dAAnPA9eweMWuAAAAAElFTkSuQmCC";

// export function appBackgroundColor(color,canvas,store){
//     console.log(store)
//     //const canvas = document.getElementsByClassName("shop-canvas")[0];
//     const ctx = canvas.getContext('2d');
//     ctx.fillStyle = color;
//     ctx.fillRect(0, 0, 1, 1);

//     const img = new Image;
//     img.onload = function(){
//         ctx.drawImage(img,0,0,1,1);
//         const p = ctx.getImageData(0, 0, 1, 1).data;
//         //console.log(p);
//         //console.log('rgba('+p[0]+','+ p[1]+','+ p[2]+','+p[3]+')');
//         //console.log(color);
//         const hex = "#" + ("000000" + rgbToHex(p[0], p[1], p[2])).slice(-6);
//         console.log(hex);

//         //const lg = 'linear-gradient(to bottom,rgba('+p[0]+','+ p[1]+','+ p[2]+',0),'+ hex +')'
//         store.set({rgbBackground:'rgba('+p[0]+','+ p[1]+','+ p[2]+',0)', hexBackground : hex});
//         };

//     img.src = backgroundDataURI;

//     function rgbToHex(r, g, b) {
//         if (r > 255 || g > 255 || b > 255)
//             throw "Invalid color component";
//         return ((r << 16) | (g << 8) | b).toString(16);
//     }
// }
